"use client";

import {
  ActionProvider,
  Renderer,
  StateProvider,
  VisibilityProvider,
  type Spec,
} from "@json-render/react";
import {
  ChatJsonRenderContextProvider,
  type ChatJsonRenderContextValue,
} from "./ChatJsonRenderContext";
import { JsonRenderRuntimeContextProvider } from "./JsonRenderRuntimeContext";
import registry from "@/src/components/Chat/StructuredCards/JsonRender/Registry";

interface ChatJsonRendererProps {
  spec: Spec;
  renderContext?: ChatJsonRenderContextValue;
}

export const ChatJsonRenderer: React.FC<ChatJsonRendererProps> = ({
  spec,
  renderContext,
}) => {
  return (
    <ChatJsonRenderContextProvider value={renderContext}>
      <JsonRenderRuntimeContextProvider
        value={{
          scene: "chat",
          chatId: renderContext?.chatId,
          streamLoading: renderContext?.streamLoading,
          collapsed: renderContext?.collapsed,
          metrics: renderContext?.metrics,
          notificationId: renderContext?.notificationId,
        }}
      >
        <StateProvider initialState={{}}>
          <VisibilityProvider>
            <ActionProvider handlers={{}}>
              <Renderer spec={spec} registry={registry} />
            </ActionProvider>
          </VisibilityProvider>
        </StateProvider>
      </JsonRenderRuntimeContextProvider>
    </ChatJsonRenderContextProvider>
  );
};
